import PropTypes from 'prop-types'

function StrokeSpinner({ size = '34' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="animate-spin"
      data-testid="stroke-spinner"
    >
      <path
        d="M17 1C25.8365 1 33 8.1635 33 17C33 25.8365 25.8365 33 17 33C8.163 33 1 25.8365 1 17"
        stroke="#13696C"
        strokeWidth="2"
      />
      <path
        d="M9 17C9 12.5815 12.5815 9 17 9C21.418 9 25 12.5815 25 17C25 21.418 21.418 25 17 25"
        stroke="#B91D7B"
        strokeWidth="2"
      />
    </svg>
  )
}

StrokeSpinner.propTypes = {
  size: PropTypes.string,
}

export default StrokeSpinner
